var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#00B976"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9062 14.875C26.0625 14.75 26.2812 14.75 26.4375 14.875L26.7812 15.25C26.9375 15.375 26.9375 15.625 26.7812 15.7812L17.4062 25.1562C17.2812 25.2812 17.0312 25.2812 16.9062 25.1562L13.1875 21.4375C13.0312 21.2812 13.0312 21.0312 13.1875 20.9062L13.5312 20.5312C13.6875 20.4062 13.9062 20.4062 14.0625 20.5312L17.1562 23.625L25.9062 14.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.897c0f81da42272a17e8e48d634213ce.svg";
export { ForwardRef as ReactComponent };